import { useEffect } from 'react';
import Router from 'next/router';
import { isRtlLocale } from 'utils/surveyLocaleUtils';

export function useLocaleAttributes(locale: string | null) {
  useEffect(() => {
    // When locale is null, preserve the lang set by the server (_document.tsx)
    if (!locale) return undefined;

    const apply = () => {
      document.documentElement.lang = locale;
      document.documentElement.dir = isRtlLocale(locale) ? 'rtl' : 'ltr';
    };
    apply();
    // With i18n enabled, the Next router resets <html lang> to its own locale after every client-side
    // route change (e.g. an in-place ?locale= switch), after this effect has run.
    Router.events.on('routeChangeComplete', apply);
    return () => Router.events.off('routeChangeComplete', apply);
  }, [locale]);
}
